import { Add } from "@mui/icons-material";
import {
  Box,
  Button,
  Card as MuiCard,
  CardContent,
  CircularProgress,
  Grid,
  Divider as MuiDivider,
  Paper,
  Stack,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
} from "@mui/material";
import { spacing } from "@mui/system";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";

const Card = styled(MuiCard)(spacing);
const Divider = styled(MuiDivider)(spacing);

function Documenti() {
  const [loadingPage, setLoadingPage] = useState(true);
  const [rows, setRows] = useState([]);
  const dispatch = useDispatch();

  const handleSnackbar = (message, severity) => {
    dispatch(showSnackbar({ message, severity }));
  };

  const navigate = useNavigate();

  const columns = [
    {
      field: "nome",
      headerName: "Nome",
      minWidth: 275,
      flex: 1,
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography
              fontWeight="bold"
              color="#407ad6"
              sx={{
                cursor: "pointer",
                ":hover": {
                  textDecoration: "underline",
                },
              }}
              onClick={() => download(params.row.idUidFile)}
            >
              {params.row.nome}
            </Typography>

            <Typography fontSize={10}>{params.row.tipologia}</Typography>
            <Typography fontSize={10}>{params.row.descrizione}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "tipo",
      headerName: "Tipo Documento",
      minWidth: 300,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params) => (
        <>
          <Box display="flex" flexDirection="column">
            <Typography fontWeight="bold">{params.row.tipo}</Typography>
          </Box>
        </>
      ),
    },
    {
      field: "descrizione",
      headerName: "Descrizione",
      minWidth: 250,
      flex: 1,
      headerAlign: "left",
      align: "left",
    },
  ];

  async function download(iduid) {
    setLoadingPage(true);
    const token = sessionStorage.getItem("token");
    try {
      const res = await fetch(
        `${API_BASE_URL}/api/documentiDownload/${iduid}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + token,
          },
          body: JSON.stringify({ token }),
        },
      );

      // Controlla se la risposta è JSON (errore) o un file (octet-stream)
      const contentType = res.headers.get("Content-Type");

      if (contentType && contentType.includes("application/json")) {
        // È un errore JSON, quindi leggi il JSON
        const response = await res.json();
        if (response.status === 0) {
          handleSnackbar(response.message, "error");
          setLoadingPage(false);
          return;
        } else {
          handleSnackbar("Errore sconosciuto", "error");
          setLoadingPage(false);
          return;
        }
      } else {
        // È un file da scaricare
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);

        // Prendi il nome file originale dall'header X-Filename, se esiste
        const originalFilename = res.headers.get("X-Filename") || iduid;

        const a = document.createElement("a");
        a.href = url;
        a.download = originalFilename; // usa il nome originale se disponibile
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        handleSnackbar("File scaricato con successo", "success");
        setLoadingPage(false);
        return;
      }
      return;
    } catch (error) {
      handleSnackbar("Download Fallito", "error");
    }
  }

  async function documentiGetList() {
    const token = sessionStorage.getItem("token");
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          wStg: 0,
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/documentiGetList`,
        requestOptions,
      );

      const responseData = await response.json();
      if (responseData.status === -1) {
        navigate("/auth/sign-in");
      }
      if (responseData.status === 0) {
        navigate("/private");
      }
      setRows(responseData.data.dataset);
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  useEffect(() => {
    documentiGetList();
  }, []);
  return (
    <>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Helmet title="Documenti" />
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h3" display="inline">
              Documenti
            </Typography>
          </Box>
          <Divider my={4} />
          <Card>
            <CardContent pb={1}>
              <Grid
                container
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography variant="h6" gutterBottom>
                    Risultati: {rows.length}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
            <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Nome</TableCell>{" "}
                    {/* Cliccabile -> Richiamo la documenti donwload passand la idUidFile */}
                    <TableCell>Tipo</TableCell>
                    <TableCell>Descrizione</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row) => (
                    <TableRow key={row.iduid}>
                      {columns.map((col) => (
                        <TableCell key={col.field}>
                          {col.renderCell ? (
                            col.renderCell({ row: row })
                          ) : (
                            <>{row[col.field]}</>
                          )}
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        </>
      )}
    </>
  );
}

export default Documenti;
